var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProTag = function SvgProTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 21,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 20,
    y: 0.115,
    fill: "url(#ProTag_svg__a)",
    rx: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5E3F04",
    d: "M10.71 6.475h2.93c1.66 0 2.51.75 2.51 2.21 0 1.45-.85 2.2-2.51 2.2h-1.45v2.23h-1.48zm1.48 3.09h1.38c.74 0 1.08-.28 1.08-.88 0-.61-.34-.89-1.08-.89h-1.38zm6.416 1.24v2.31h-1.48v-6.64h2.98c1.66 0 2.51.74 2.51 2.17 0 1.06-.47 1.74-1.39 2.01l1.59 2.46h-1.74l-1.35-2.31zm0-1.32h1.44c.73 0 1.07-.27 1.07-.84 0-.58-.34-.85-1.07-.85h-1.44zm8.3-3.11c2.05 0 3.49 1.42 3.49 3.42s-1.44 3.42-3.49 3.42-3.49-1.42-3.49-3.42 1.44-3.42 3.49-3.42m0 1.32c-1.18 0-1.99.86-1.99 2.1s.81 2.1 1.99 2.1 1.99-.86 1.99-2.1-.81-2.1-1.99-2.1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "ProTag_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-168.892 10.242 4.11)scale(18.5751 10.3573)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAEBB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1A81A"
  })))));
};
export default SvgProTag;